import { render, staticRenderFns } from "./video-upload.vue?vue&type=template&id=668448f2&scoped=true"
import script from "./video-upload.vue?vue&type=script&scoped=true&lang=js"
export * from "./video-upload.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./video-upload.vue?vue&type=style&index=0&id=668448f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668448f2",
  null
  
)

export default component.exports